import { PlessViewUtilsSub } from '../../../../commons/kymw00/pless-view-utils-sub.service';
import { FileDownloadConfirmService } from '../../../../commons/kymw02/file-download-confirm/file-download-confirm.service';
import { KomaPrintDataModel } from '../../kymw1400/vo/koma-print-date.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * コマ印刷データを取得する。
 *
 * @export
 * @class GetKomaPrintDataService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class GetKomaPrintDataService extends PlessJsonResponderSub<any> {

  private vo: KomaPrintDataModel = null;
  private fileDownloadConfirmService: FileDownloadConfirmService = null;

  private orderCode = String('');									// 受注コード
  private mediumType = String('');								// 媒体区分

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetKomaPrintDataService
   */
  private getBody(): PlessRequest {
    // 生協リストを作成する
    const coopCodes =
      ((0 == this.vo.coopCodeList.length) ? [ null ] : this.vo.coopCodeList)
        .map(coopCode => ({
          condition: {
            CoopCode: coopCode,
            PageNum: null
          }
        }));

    // ページ番号リストを作成する
    const pageNums = this.vo.pageArray.map(pageNum => ({
      condition: {
        CoopCode: null,
        PageNum: pageNum
      }
    }));

    const combinations = coopCodes.concat(pageNums);

    return new PlessRequest({
      search: {
        KomaPrintData: {
          condition: {
            OrderCode: this.vo.orderCode,
            CatalogId: this.vo.catalogId,
            MediumType: this.vo.mediumType,
            MediumName: this.vo.mediumName,
            ShowKoma: this.vo.showKoma,
            ShowGoods: this.vo.showGoods,
            ShowImage: this.vo.showImage
          },
          combination: combinations,
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {KomaPrintDataModel} vo
   * @param {FileDownloadConfirmService} fileDownloadConfirmService
   * @memberof GetKomaPrintDataService
   */
  execute(vo: KomaPrintDataModel, fileDownloadConfirmService: FileDownloadConfirmService) {
    this.vo = vo;
    this.orderCode = vo.orderCode;
    this.mediumType = vo.mediumType;
    this.fileDownloadConfirmService = fileDownloadConfirmService;
    this.send('getKomaPrintData', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetKomaPrintDataService
   */
  success(data: any) {
    if (data != null) {
      if (!PlessViewUtilsSub.isEmpty(data.FileName)) {
        const fileName = String('誌面印刷_' + this.orderCode + '_' + this.mediumType + '.zip');

        this.fileDownloadConfirmService.show(data.FileName, fileName);
      }
    }
  }
}
